import {head, isNil} from 'ramda';

/** Step a slider falls back to when the brackets do not define a usable distance. */
const FALLBACK_STEP = 1;

function greatestCommonDivisor(left: number, right: number): number {
  return right === 0 ? left : greatestCommonDivisor(right, left % right);
}

/**
 * The largest slider step that still reaches every bracket: the greatest common divisor of the
 * distances between them.
 *
 * Balloon payments are a fixed set of percentage brackets (`VehicleFinancingBalloonPayment`), so a
 * slider that moves in finer steps stops on values no rate cell can hold and the thumb is pushed
 * back to the previous bracket.
 */
export function getBracketSliderStep(brackets: number[]) {
  const sortedBrackets = [...brackets].sort((left, right) => left - right);
  const firstBracket = head(sortedBrackets);

  if (isNil(firstBracket)) {
    return FALLBACK_STEP;
  }

  const step = sortedBrackets.reduce(
    (currentStep, bracket) => greatestCommonDivisor(currentStep, bracket - firstBracket),
    0
  );

  return step === 0 ? FALLBACK_STEP : step;
}
